export default __webpack_public_path__ + "static/media/harmonyprint.513a9b8e.jpg";